import React, { Component } from 'react'


class Footer extends Component {
  render() {
    return (
      <footer>
        <p>Desenvolvido por Hiago Peroni</p>
      </footer>
    )
  }
}

export default Footer;